module.exports = __webpack_public_path__ + "static/img/Noah-Mraz.f88c511.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Noah-Mraz.jpg
// module id = FhVx
// module chunks = 0